import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const DancingLetters = ({ title, once = true }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.5, once: once });

  const dancingLetterAnimation = {
    hidden: {
      opacity: 0,
      x: -40,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.4,
        duration: 0.8,
        type: "linear",
        stiffness: 180,
      },
    },
  };

  return (
    <span ref={ref}>
      <motion.span
        variants={dancingLetterAnimation}
        initial={"hidden"}
        animate={isInView ? "visible" : "hidden"}
        className="inline-block"
      >
        {title}
      </motion.span>
    </span>
  );
};

export default DancingLetters;
